import { api } from "./client";

export function listReports({ signal } = {}) {
  return api("/api/runs", { signal });
}
